export default __webpack_public_path__ + "static/burger-3a22b347c8a7a086a32b4989ef1e9f7e.png";